const firebaseConfig = {
    apiKey: "AIzaSyCY3lqR4MAlIu2LyE0Oqte6YhXalb56cJE",
    authDomain: "helping-hand-cd7d6.firebaseapp.com",
    projectId: "helping-hand-cd7d6",
    storageBucket: "helping-hand-cd7d6.appspot.com",
    messagingSenderId: "108353944419",
    appId: "1:108353944419:web:fc4da0fc1a549ac7f67156"



    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_FIREBASE_APP_ID
};
export default firebaseConfig